import { render, staticRenderFns } from "./DashboardOpportunityList.vue?vue&type=template&id=2f71854b&scoped=true&"
import script from "./DashboardOpportunityList.vue?vue&type=script&lang=js&"
export * from "./DashboardOpportunityList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOpportunityList.vue?vue&type=style&index=0&id=2f71854b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f71854b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCard: require('/workspace/components/Dashboard/DashboardCard.vue').default})
